import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { ImageIcon, FolderKanban, Users, Newspaper, Briefcase, Inbox } from "lucide-react";

const TILES = [
  { key: "hero-slides", label: "Hero Slides", icon: ImageIcon },
  { key: "projects", label: "Projects", icon: FolderKanban },
  { key: "leaders", label: "Leaders", icon: Users },
  { key: "blogs", label: "Blogs", icon: Newspaper },
  { key: "careers", label: "Careers", icon: Briefcase },
];

export default function AdminDashboard() {
  const [counts, setCounts] = useState({});
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    const load = async () => {
      const next = {};
      for (const t of TILES) {
        try {
          const { data } = await api.get(`/${t.key}?active_only=false`);
          next[t.key] = data.length;
        } catch {
          next[t.key] = 0;
        }
      }
      try {
        const { data } = await api.get("/admin/leads");
        next["leads"] = data.length;
        setLeads(data.slice(0, 5));
      } catch {
        next["leads"] = 0;
      }
      setCounts(next);
    };
    load();
  }, []);

  return (
    <div data-testid="admin-dashboard" className="space-y-10">
      <div>
        <div className="section-overline">Overview</div>
        <h1 className="font-display text-4xl font-semibold text-[#0A1128] mt-3">Welcome to GESIL CMS.</h1>
        <p className="mt-2 text-slate-600">Manage published content, monitor incoming consultations, and orchestrate the public experience.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {TILES.map((t) => {
          const Icon = t.icon;
          return (
            <div key={t.key} data-testid={`stat-${t.key}`} className="bg-white rounded-xl border border-blue-100 p-6 hover:border-[#2563EB] transition-colors">
              <div className="flex items-center justify-between">
                <div className="overline">{t.label}</div>
                <Icon size={18} className="text-blue-300" />
              </div>
              <div className="mt-4 font-display text-4xl font-semibold text-[#1E3A8A]">{counts[t.key] ?? "—"}</div>
            </div>
          );
        })}
        <div data-testid="stat-leads" className="bg-gradient-to-br from-[#2563EB] to-[#1E3A8A] text-white rounded-xl p-6 shadow-[0_24px_48px_-24px_rgba(37,99,235,0.55)]">
          <div className="flex items-center justify-between">
            <div className="overline" style={{ color: "#DBEAFE" }}>New Leads</div>
            <Inbox size={18} className="text-white/90" />
          </div>
          <div className="mt-4 font-display text-4xl font-semibold">{counts["leads"] ?? "—"}</div>
          <div className="mt-2 text-xs text-white/80">Consultation & demo requests</div>
        </div>
      </div>

      <div>
        <h2 className="font-display text-2xl font-semibold text-[#0A1128]">Latest leads</h2>
        <div className="mt-4 bg-white border border-slate-200 rounded-xl overflow-hidden">
          {leads.length === 0 && <div className="p-6 text-sm text-slate-500">No leads yet.</div>}
          {leads.map((l) => (
            <div key={l.id} className="flex items-center justify-between p-5 border-b border-slate-100 last:border-b-0">
              <div>
                <div className="font-semibold text-[#0A1128]">{l.name} · <span className="text-slate-500 font-normal">{l.email}</span></div>
                <div className="text-sm text-slate-600 mt-1 line-clamp-1">{l.message}</div>
              </div>
              <div className="text-xs text-slate-400">{l.interest}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
